import { styled } from "@mui/material/styles";

const Toggle = styled("input")(({ theme }) => ({
  marginTop: 0,
  display: "inline-block",
  height: "16px",
  width: "32px",
  cursor: "pointer",
  outline: "none",
  border: 0,
  position: "relative",
  appearance: "none",
  verticalAlign: "middle",
  flexShrink: 0,
  "&::before,&::after": {
    position: "absolute",
    top: 0,
    borderRadius: "9999px",
    content: '""',
  },
  "&::before": {
    display: "inline-block",
    height: "16px",
    width: "32px",
    boxShadow: "inset 0 0 #000",
    backgroundColor: "#d1d5db",
  },
  "&::after": {
    display: "block",
    marginLeft: 0,
    marginTop: 0,
    height: "16px",
    width: "16px",
    border: "1px solid #d1d5db",
    boxShadow:
      "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
    transitionDuration: "100ms",
    backgroundColor: "white",
  },
  "&:checked::before": {
    background: "#B0E0D4",
  },
  "&:checked::after": {
    height: "16px",
    width: "16px",
    border: 0,
    background: theme.palette.cf.cfPrimary,
    transform: "translateX(1.25rem)",
  },
  "&:disabled": {
    cursor: "not-allowed",
    opacity: 0.5,
  },
}));

Toggle.defaultProps = {
  type: "checkbox",
};

export { Toggle };
